import type { BillingTier } from "schemas/generated/billing";

import React from "react";

import Coin from "@svg/billing/Coin";
import ProIconGlobe from "@svg/billing/Globe";
import PaperAirplane from "@svg/billing/PaperAirplane";

import { exhaustiveSwitch } from "replo-utils/lib/misc";
import { getBillingPlanInfoByTier } from "schemas/billing";

const getPlanIcon = (tier: BillingTier) => {
  return exhaustiveSwitch({ type: tier })({
    free: <PaperAirplane />,
    starter: <Coin />,
    pro: <ProIconGlobe />,
  });
};

export const PlanLabel = ({ tier }: { tier: BillingTier }) => {
  return (
    <div className="flex justify-start items-center gap-1">
      {getPlanIcon(tier)}
      <span className="font-editorial text-2xl font-normal">
        {getBillingPlanInfoByTier(tier).displayName}
      </span>
    </div>
  );
};
